import {Network} from "./Network"

export class AppService {
    static findBySlug (slug) {
        return Network.fetch(true,`/app/${slug}`)
    }
}
